module.exports = __webpack_public_path__ + "static/media/clock.6f8e9085.svg";